<lib-slide-toggle
    [checked]="bindingProperty"
    (checkedChange)="dataChanged($event)"
    [isReadOnly]="isReadOnly"
></lib-slide-toggle>
